module.exports = __webpack_public_path__ + "clickup-integration-1-6cee64e8a77ff760e7a1ff8e603be8fb.webp";